function initSliders(root) {
  root.querySelectorAll('[data-slider]:not([data-slider-initialized])').forEach((slider) => {
    slider.dataset.sliderInitialized = 'true';

    const track = slider.querySelector('[data-slider-track]');
    const dots = slider.querySelectorAll('.slider-dot');
    const prevButton = slider.querySelector('[data-slider-prev]');
    const nextButton = slider.querySelector('[data-slider-next]');
    const items = track ? Array.from(track.children) : [];

    if (!track || !items.length) return;

    let currentIndex = 0;

    const setActive = (index) => {
      currentIndex = index;

      dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (prevButton) prevButton.disabled = index === 0;
      if (nextButton) nextButton.disabled = index === items.length - 1;
    };

    const goToIndex = (index) => {
      const clamped = Math.max(0, Math.min(items.length - 1, index));
      items[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(items.indexOf(entry.target));
          }
        });
      },
      { root: track, threshold: 0.6 }
    );

    items.forEach((item) => observer.observe(item));
    setActive(0);

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToIndex(i));
    });

    if (prevButton) prevButton.addEventListener('click', () => goToIndex(currentIndex - 1));
    if (nextButton) nextButton.addEventListener('click', () => goToIndex(currentIndex + 1));
  });
}

document.addEventListener('DOMContentLoaded', () => initSliders(document));
document.addEventListener('shopify:section:load', (event) => initSliders(event.target));
